import React, { useState } from "react";
import { connect } from "react-redux";
import { SelectionControlGroup } from "react-md";
import { getPhotoButtonHoverSetting, getPhotoTagSetting, photoToolButtonHoverOptions, getPhotoNumbersSetting, photoToolPhotoNumberingOptions, getPhotoSizeSetting, photoSizeMetaData, PhotoSizeMeta, photoTagHoverSettings } from "components/Photos/PhotoTool/Shared";
import { savePreference } from "actions/preferences";
import { PhotoButtonSetting, PhotoNumberingSetting, PhotoSizeSetting, PhotoTagSetting } from "typeConstants/preferenceTypes";
import { UserPreference } from "interfaces/Mueller.Business.Models";

interface IPhotoTagSettingsProps {
  preferences: UserPreference[],
  savePreference: (code: string, value: string, callback?: () => void) => void
}

const PhotoTagSettings = ({preferences, savePreference}: IPhotoTagSettingsProps) => {
  const [hoverSetting, setHoverSetting] = useState(getPhotoTagSetting(preferences));
  const [photoNumbersSetting, setPhotoNumbersSetting] = useState(getPhotoNumbersSetting(preferences));
  const [buttonSetting, setButtonSetting] = useState(getPhotoButtonHoverSetting(preferences));
  const [sizeSetting, setSizeSetting] = useState<PhotoSizeMeta>(getPhotoSizeSetting(preferences));

  return (
    <div className={"photo-tag-settings"}>
      <SelectionControlGroup
        type={"radio"}
        label={"Photo Sizes"}
        name={"photo-size-options"}
        id={"photo-size-options"}
        className={"mueller-radio"}
        inline
        controls={[
          {
            label: photoSizeMetaData.EXTRA_SMALL.label,
            value: photoSizeMetaData.EXTRA_SMALL.preferenceCode
          },
          {
            label: photoSizeMetaData.SMALL.label,
            value: photoSizeMetaData.SMALL.preferenceCode
          },
          {
            label: photoSizeMetaData.MEDIUM.label,
            value: photoSizeMetaData.MEDIUM.preferenceCode
          },
          {
            label: photoSizeMetaData.LARGE.label,
            value: photoSizeMetaData.LARGE.preferenceCode
          },
          {
            label: photoSizeMetaData.EXTRA_LARGE.label,
            value: photoSizeMetaData.EXTRA_LARGE.preferenceCode
          }
        ]}
        defaultValue={sizeSetting.preferenceCode}
        onChange={newSizeSetting => {
          if (newSizeSetting !== sizeSetting.preferenceCode) {
            savePreference(PhotoSizeSetting, newSizeSetting);
            setSizeSetting(photoSizeMetaData[newSizeSetting]);
          }
        }}
      />
      <SelectionControlGroup
        type={"radio"}
        label={"Photo Tags"}
        name={"hover-options"}
        id={"hover-options"}
        className={"mueller-radio"}
        inline
        controls={[
          {
            label: "Hide",
            value: photoTagHoverSettings.HIDE,
          },
          {
            label: "Show on Hover",
            value: photoTagHoverSettings.HOVER,
          },
          {
            label: "Show",
            value: photoTagHoverSettings.SHOW,
          }
        ]}
        defaultValue={hoverSetting}
        onChange={newHoverSetting => {
          if (newHoverSetting !== hoverSetting) {
            savePreference(PhotoTagSetting, newHoverSetting);
            setHoverSetting(newHoverSetting);
          }
        }}
      />
      <SelectionControlGroup
        type={"radio"}
        label={"Photo Numbering"}
        name={"photo-numbering"}
        id={"photo-numbering"}
        className={"mueller-radio"}
        inline
        controls={[
          {
            label: "Hide",
            value: photoToolPhotoNumberingOptions.HIDE_NUMBERS
          },
          {
            label: "Show on Hover",
            value: photoToolPhotoNumberingOptions.SHOW_ON_HOVER
          },
          {
            label: "Show",
            value: photoToolPhotoNumberingOptions.SHOW_NUMBERS_ALWAYS
          }
        ]}
        defaultValue={photoNumbersSetting}
        onChange={newPhotoNumbersSetting => {
          if (newPhotoNumbersSetting !== photoNumbersSetting) {
            savePreference(PhotoNumberingSetting, newPhotoNumbersSetting);
            setPhotoNumbersSetting(newPhotoNumbersSetting);
          }
        }}
      />
      <SelectionControlGroup
        type={"radio"}
        label={"Buttons"}
        name={"button-options"}
        id={"button-options"}
        className={"mueller-radio"}
        inline
        controls={[
          {
            label: "Show on Hover",
            value: photoToolButtonHoverOptions.SHOW_ON_HOVER,
          },
          {
            label: "Show",
            value: photoToolButtonHoverOptions.SHOW_ALWAYS,
          },
        ]}
        defaultValue={buttonSetting}
        onChange={newButtonSetting => {
          if (newButtonSetting !== buttonSetting) {
            savePreference(PhotoButtonSetting, newButtonSetting);
            setButtonSetting(newButtonSetting);
          }
        }}
      />
    </div>
  );
};

const mapStateToProps = state => ({
  preferences: state.preferences
});

const mapDispatchToProps = dispatch => ({
  savePreference(code, value, callback) {
    dispatch(savePreference(code, value, callback));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PhotoTagSettings);
